/* eslint-disable react/no-danger */
import Head from 'next/head';
import { Col, Container, Row } from 'reactstrap';

import Layout from '../../components/layout/layout';
import TandCJp from '../../components/pages/tc_jp';
import useI18n from '../../hooks/use-i18n';
import { languages, contentLanguageMap } from '../../language.config';
import getTranslationKeys, { PAGEID } from '../../utils/i18nRosseta';

import '../../styles/privacy.scss';

const sections = [
  'section_one',
  'section_two',
  'section_three',
  'section_four',
  'section_five',
  'section_six',
  'section_seven',
  'section_eight',
  'section_nine',
  'section_ten',
  'section_eleven',
  'section_twelve',
  'section_thirteen',
  'section_fourteen',
  'section_fifteen',
  'section_sixteen',
  'section_seventeen',
  'section_eighteen',
  'section_nineteen',
  'section_twenty'
];

const TermsAndConditions = () => {
  const i18n = useI18n();
  const termsAndConditions = i18n.t('terms_and_conditions');
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';
  const pageMetaData = i18n.t('metadata').terms_conditions;

  return (
    <Layout
      page="tac"
      description={pageMetaData.description}
      title={pageMetaData.title}
      keywords={pageMetaData.keywords}
      analyticData={{ name: 'Terms & Conditions', properties: { } }}
      pageUrl="website-terms-and-conditions"
      pageEnabledMarkets={[]}
    >
      <Head />
      {country !== 'jp' ? (
        <section className="content-page-wrapper">
          <Container>
            <Row>
              <Col xl={{ size: 8, order: 2, offset: 2 }}>
                <h1>{termsAndConditions.title}</h1>
                <div dangerouslySetInnerHTML={{ __html: termsAndConditions.first_para }} />
                <ol>
                  {sections.map((section) => <div dangerouslySetInnerHTML={{ __html: termsAndConditions[section] }} />)}
                </ol>
              </Col>
            </Row>
          </Container>
        </section>
      ) : (
        <TandCJp />
      )}
    </Layout>
  );
};

export async function getStaticProps({ params }) {
  const lngDict = {};
  const pageId = PAGEID.WEBSITE_TERMS_AND_CONDITIONS;
  const keys = getTranslationKeys(pageId);
  const { default: lngDictAll = {} } = await import(
    `../../locales/${contentLanguageMap[params.lng]}.json`
  );
  keys.forEach((data) => {
    lngDict[data] = lngDictAll[data];
  });
  return {
    props: { lng: params.lng, lngDict, pageId }
  };
}

export async function getStaticPaths() {
  return {
    paths: languages.map((l) => ({ params: { lng: l } })),
    fallback: false
  };
}

export default TermsAndConditions;
